import React, { Component } from 'react';
import { inject, observer } from 'mobx-react/index';
import { Icon, Tooltip, Row, Col, Badge, Button, Popover, Tag } from 'antd';
import { withRouter, Link } from 'react-router-dom';
import moment from 'moment';

@withRouter
@inject('store')
@observer
export class StatusPanel extends Component {
    render() {
        const connected = this.props.store.botStore.connected;
        const bot = this.props.store.botStore.bots[this.props.match.params.id];
        const poolStatus = this.props.store.botStore.poolBindings[bot.pool_id];

        const strat = this.props.store.strategyStore.strategies.filter(
            s => s.id === bot.strategy_id
        )[0];

        const controlPanel = (
            <div style={{ width: 250 }}>
                <Button
                    style={{ marginBottom: 5 }}
                    block
                    disabled={bot.triggers_enabled}
                    type={bot.buy_enabled ? 'primary' : 'danger'}
                    onClick={() =>
                        this.props.store.botStore.updateConfigValue('buy_enabled', !bot.buy_enabled)
                    }
                >
                    {bot.buy_enabled ? <span>Buying Enabled</span> : 'Buying Disabled'}{' '}
                </Button>

                <Button
                    style={{ marginBottom: 5 }}
                    block
                    type={bot.triggers_enabled ? 'primary' : 'danger'}
                    onClick={() =>
                        this.props.store.botStore.updateConfigValue(
                            'triggers_enabled',
                            !bot.triggers_enabled
                        )
                    }
                >
                    {bot.triggers_enabled ? <span>Automation Enabled</span> : 'Automation Disabled'}{' '}
                </Button>

                <Button
                    style={{ marginBottom: 5 }}
                    block
                    disabled={bot.triggers_enabled}
                    type={bot.sell_enabled ? 'primary' : 'danger'}
                    onClick={() =>
                        this.props.store.botStore.updateConfigValue(
                            'sell_enabled',
                            !bot.sell_enabled
                        )
                    }
                >
                    {' '}
                    {bot.sell_enabled ? <span>Selling Enabled</span> : 'Selling Disabled'}
                </Button>

                <Button
                    style={{ marginBottom: 5 }}
                    block
                    type={bot.auto_dca_enabled ? 'primary' : 'danger'}
                    onClick={() =>
                        this.props.store.botStore.updateConfigValue(
                            'auto_dca_enabled',
                            !bot.auto_dca_enabled
                        )
                    }
                >
                    {' '}
                    {bot.auto_dca_enabled ? <span>Auto DCA Enabled</span> : 'Auto DCA Disabled'}
                </Button>

                <Button
                    style={{ marginBottom: 5 }}
                    block
                    type={bot.auto_reverse_enabled ? 'primary' : 'danger'}
                    onClick={() =>
                        this.props.store.botStore.updateConfigValue(
                            'auto_reverse_enabled',
                            !bot.auto_reverse_enabled
                        )
                    }
                >
                    {' '}
                    {bot.auto_reverse_enabled ? (
                        <span>Auto Reverse Trading Enabled</span>
                    ) : (
                        'Auto Reverse Trading Disabled'
                    )}
                </Button>

                <Button
                    style={{ marginBottom: 5 }}
                    block
                    type={'primary'}
                    onClick={() => this.props.store.botStore.reboot()}
                >
                    Reboot
                </Button>
            </div>
        );

        return (
            <div className="status-panel">
                <div className={'inner'}>
                    <Row gutter={24}>
                        <Col xs={24} sm={12}>
                            <div style={{ display: 'inline-block', marginRight: 10 }}>
                                <img
                                    height="32px"
                                    style={{ marginTop: 6, marginRight: 10 }}
                                    alt={`${bot.exchange} logo`}
                                    src={`/exchanges/${bot.exchange}.png`}
                                />
                                <span style={{ fontSize: 16, position: 'relative', top: 4 }}>
                                    <b>
                                        {bot.name} ({bot.base_currency})
                                    </b>{' '}
                                    - {strat !== undefined ? strat.name : 'Undefined Strategy'}
                                </span>
                                <br />
                                <span>
                                    <i className="fal fa-life-ring success" /> Support key:{' '}
                                    <Tag>{poolStatus.id}</Tag>
                                </span>
                            </div>
                        </Col>
                        <Col xs={24} sm={12} className={'text-right'}>
                            <Tooltip title={'Bot Connection'}>
                                {connected ? (
                                    <Icon type="wifi" theme="outlined" className="connected" />
                                ) : (
                                    <Icon type="wifi" theme="outlined" className="not-connected" />
                                )}
                            </Tooltip>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <span className={'status-list'}>
                                <Badge
                                    status={bot.buy_enabled ? 'success' : 'error'}
                                    text="Buying"
                                />
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <Badge
                                    status={bot.triggers_enabled ? 'success' : 'error'}
                                    text="Automation"
                                />
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <Badge
                                    status={bot.sell_enabled ? 'success' : 'error'}
                                    text="Selling"
                                />
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <Badge
                                    status={bot.auto_dca_enabled ? 'success' : 'error'}
                                    text="ADCA"
                                />
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <Badge
                                    status={bot.auto_reverse_enabled ? 'success' : 'error'}
                                    text="ART"
                                />
                            </span>
                            &nbsp;&nbsp;
                            <Popover
                                placement="bottomRight"
                                content={controlPanel}
                                title="Control Panel"
                                trigger="click"
                            >
                                <Button size="small" type="primary" shape="circle" icon="setting" />
                            </Popover>
                            &nbsp;&nbsp;
                            <Button
                                size="small"
                                onClick={() =>
                                    this.props.store.userStore.updateProfile({
                                        sound: !this.props.store.userStore.currentUser.sound
                                    })
                                }
                                type={
                                    this.props.store.userStore.currentUser.sound
                                        ? 'primary'
                                        : 'danger'
                                }
                                shape="circle"
                                icon="sound"
                            />
                        </Col>
                    </Row>
                    {this.props.children}
                </div>
            </div>
        );
    }

    renderBotTime() {
        const bot = this.props.store.botStore.bots[this.props.match.params.id];
        const poolStatus = this.props.store.botStore.poolBindings[bot.pool_id];

        return (
            <span style={{ fontSize: 12 }}>
                Sub Renewal: {moment(poolStatus.sub_expiry).format('DD/MM/YYYY')}
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <Link to={`/a/bot/${this.props.match.params.id}/legacy_subscription`}>
                    Manage Subscription
                </Link>
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/StatusPanel.js